/** @format */

import { Injectable } from '@angular/core';
import { BreakPointNew } from '@shared/data-access/enums';
import { ProductStyle } from '@shared/data-access/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProductSelectionUtilityService {
  /**
   * @description converts date string of '11-19-2021' to '2021-11-19' then formats it in a way
   * so the angular date pipe can use it
   * @return date in milliseconds
   */
  formatDateToTimestamp(dateValue: string): number {
    const splitDate = dateValue.split('-').slice(-3);
    const defaultTime = 'T00:00:00';
    const shiftYear = splitDate.splice(2, 1)[0];

    splitDate.splice(0, 0, shiftYear);
    const formattedDate = `${splitDate.join('-')}${defaultTime}`;
    return Date.parse(formattedDate);
  }

  /**
   * @description takes in a zipcode as a string and checks that it matches the regex for
   * a US zip code
   * valid formats : 15108 or 15108-0039
   * @param zipcode
   * @returns boolean
   */
  isValidZipCode(zipcode: string): boolean {
    return /\b\d{5}\b/.test(zipcode);
  }

  /**
   * Given a set of values per their screen size, and the current breakpoint, return
   * the correct value for the current screen size.
   * @param values A mapping of screen sizes to values.
   * @param currentBreakpoint The largest breakpoint that the screen size is currently larger than.
   */
  getValueByScreenSize<T>(
    values: { desktop: T; mobile: T; tablet: T },
    currentBreakpoint: BreakPointNew,
  ): T {
    if (currentBreakpoint < BreakPointNew.MEDIUM) {
      return values.mobile;
    }
    if (currentBreakpoint === BreakPointNew.MEDIUM) {
      return values.tablet;
    }
    return values.desktop;
  }

  static getStyleRatingValue(style: ProductStyle | Record<string, never>) {
    if ('ratingValue' in style) {
      return style.ratingValue;
    }
    let ratingValue: number = undefined;
    if (style.descriptiveAttributes) {
      for (const attr of style.descriptiveAttributes) {
        if (attr.identifier === 'X_BazaarVoice_ratings_ovr_DSG') {
          return attr.value as number;
        }
        if (attr.identifier === 'X_BazaarVoice_ratings_DSG') {
          ratingValue = attr.value as number;
        }
      }
    }
    return ratingValue;
  }
}
